import React, { useState, useEffect } from 'react'
import ImageConverter from './components/ImageConverter'
import { sdk } from '@farcaster/miniapp-sdk'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { config } from './config/wagmi'
import './App.css'

const queryClient = new QueryClient()

function App() {
  console.log('App component loaded!')
  const [isLoading, setIsLoading] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  // Call sdk.actions.ready() when app is fully loaded
  useEffect(() => {
    const initializeApp = async () => {
      try {
        console.log('App is ready, calling sdk.actions.ready()')
        await sdk.actions.ready()
        console.log('✅ sdk.actions.ready() called successfully')
      } catch (error) {
        console.log('⚠️ sdk.actions.ready() failed (this is normal in non-mini-app environments):', error)
      }
    }

    initializeApp()
  }, [])

  const appContent = (
    <div className="app">
      {/* Background decorative elements */}
      <div className="bg-decoration bg-decoration-1"></div>
      <div className="bg-decoration bg-decoration-2"></div>
      <div className="bg-decoration bg-decoration-3"></div>
      
      <div className="app-buffer">
        <div className="container">
        <header className="app-header">
          <div className="title-section">
            <a href="/" className="logo-link">
              <img src="/app_logo.png" alt="base it" className="title-logo" />
            </a>
          </div>
          <p className="header-description">Flood the feeds with Base blue!</p>
        </header>

        <div className={`app-explanation ${selectedImage ? 'collapsed' : ''}`}>
          <p className="explanation-text">Transform any image into a blue stripe masterpiece</p>
          <div className="example-flow">
            <div className="example-item">
              <img src="/input_sydney.jpg" alt="Basic example" className="example-image" />
              <span className="example-label">Basic</span>
            </div>
            <div className="arrow-container">
              <img src="/transform_icon_base_02.png" alt="Arrow" className="arrow-icon" />
            </div>
            <div className="example-item">
              <img src="/output_sydney.jpg" alt="Based example" className="example-image" />
              <span className="example-label">Based</span>
            </div>
          </div>
        </div>

        <div className="app-content">
          <ImageConverter onImageSelect={setSelectedImage} />
        </div>

        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-card">
              <div className="loading-spinner">
                <div className="base-logo loading">
                  <div className="logo-square"></div>
                </div>
              </div>
              <p>Processing your image...</p>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  )

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        {appContent}
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default App 